import { useEffect, useRef, useState } from 'react';

import { useCatalogProductIdParams } from '@domains/pdp-common';

import { overseas_direct_purchase_size_tab, tab_list, TabName } from '../constant/size-table';
import { useSizeInfo } from '../queries/useSizeInfoQuery';

export const useSizeInfoService = () => {
  const param = useCatalogProductIdParams();
  const { data: itemList } = useSizeInfo(param);
  const language = 'ko';

  const only_once = useRef<boolean>(false);
  const [active_tab, setActiveTab] = useState<TabName>(TabName.woman);

  useEffect(() => {
    if (only_once.current || !itemList?.managed_category_list) {
      return;
    }

    const categories = itemList.managed_category_list;
    const isWomanWear = categories.some((c) => c.key === 'luxuries_posty_women_wear');
    const isManWear = categories.some((c) => c.key === 'luxuries_posty_men_wear');
    const isShoes = categories.some((c) => ['luxuries_posty_women_shoes', 'luxuries_posty_men_shoes'].includes(c.key));

    if (isWomanWear) {
      setActiveTab(TabName.woman);
    } else if (isManWear) {
      setActiveTab(TabName.man);
    } else if (isShoes) {
      setActiveTab(TabName.shoes);
    }

    only_once.current = true;

    if (itemList?.managed_category_list?.length) {
      only_once.current = true;
      itemList.managed_category_list.forEach((category) => {
        if (category.key === 'luxuries_posty_women_wear') {
          setActiveTab(TabName.woman);
        } else if (category.key === 'luxuries_posty_men_wear') {
          setActiveTab(TabName.man);
        } else if (category.key === 'luxuries_posty_women_shoes' || category.key === 'luxuries_posty_men_shoes') {
          setActiveTab(TabName.shoes);
        }
      });
    }
  }, [itemList]);

  const hideOverseas = !itemList?.trait_list?.find((o) => o.type === 'OVERSEAS_DIRECT_PURCHASE');
  const hasActualSizeInfo = Boolean(itemList?.item_list?.length);
  const hasAiCropSizeInfo = Boolean(itemList?.item_list?.find((item) => item.is_ai_image_zoom_button_visible));
  const isKorean = language === 'ko';

  const table_list = overseas_direct_purchase_size_tab[active_tab];

  const onClickTab = (tab: TabName) => {
    setActiveTab(tab);
  };

  return {
    hideActualSize: hasAiCropSizeInfo,
    hideAiCropSize: !hasAiCropSizeInfo,
    hideSizeGuide: isKorean,
    hideOverseas,
    tab_list,
    table_list,
    active_tab,
    onClickTab,
  };
};
